import { CarriageGroupStatusMnemonicEnum } from '@constants/apiEnums';

import { METHODS } from '@system/acl/methods';
import type { UserInfo, matchesFn } from '@system/acl/types';

import { EAppRouteStatus } from '@utils/enums';

export function carriageGroupMatch(
  matches: Map<string, matchesFn>,
  userInfo: UserInfo,
): void {
  /** =======================[ Редактирование группы вагонов ]====================== */
  // Редактировать/удалять ГВ можно только в статусе "На редактировании"
  // Сначала смотрим есть ли право редактирования у пользователя
  // Роль фпк + право на редактирование = филиалы игнорируются
  // Роль филиальная + право на редактирование = смотрим, чтобы филиал совпадал
  // Либо у ГВ нет филиала
  matches.set(METHODS.carriageGroups.updateCarriageGroup, conditions => {
    // TODO: Проверить что это условие не поломало всю остальную логику
    if (conditions?.status === CarriageGroupStatusMnemonicEnum.pending) {
      return (
        userInfo.isFpk ||
        conditions?.branchId === userInfo?.branchId ||
        !conditions?.branchId
      );
    } else {
      return false;
    }
  });

  matches.set(METHODS.carriageGroups.deleteCarriageGroup, conditions => {
    if (conditions?.status === CarriageGroupStatusMnemonicEnum.pending) {
      return (
        userInfo.isFpk ||
        conditions?.branchId === userInfo?.branchId ||
        !conditions?.branchId
      );
    } else {
      return false;
    }
  });

  matches.set(
    METHODS.carriageGroups.createCarriageGroup,
    conditions => conditions?.status === EAppRouteStatus.StatusPlanning,
  );

  matches.set(METHODS.carriageGroups.revoke, conditions => {
    return (
      conditions?.carriageGroupStatus !==
        CarriageGroupStatusMnemonicEnum.pending &&
      conditions?.status === EAppRouteStatus.StatusPlanning
    );
  });
}
